<script lang="ts">
  import Button from "@/components/Button.svelte";
  import { onMount } from "svelte";

  onMount(() => {
    window.dataLayer.push({ event: "results_not_found_shown" });
  });
</script>

<h3>No slots available</h3>
<p style="max-width: 35rem;">
  We'll reach out to you once we have availability that fits your selected preferences. If you'd like to reach out
  instead, please schedule a time with one of our matching specialists to find your perfect Board Certified Dietitian.
</p>
<Button onclick={() => window.dataLayer.push({ event: "results_not_found_clicked" })} element="a" href="/results"
  >Schedule a call</Button
>
